var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllergen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.841 15.659L18.017 15.836L18.195 15.659C18.4039 15.4501 18.652 15.2843 18.925 15.1713C19.1979 15.0582 19.4905 15 19.786 15C20.0815 15 20.3741 15.0582 20.647 15.1713C20.92 15.2843 21.1681 15.4501 21.377 15.659C21.5859 15.8679 21.7517 16.116 21.8647 16.389C21.9778 16.6619 22.036 16.9545 22.036 17.25C22.036 17.5455 21.9778 17.8381 21.8647 18.111C21.7517 18.384 21.5859 18.6321 21.377 18.841L18.017 22.2L14.659 18.841C14.237 18.419 14 17.8467 14 17.25C14 16.6533 14.237 16.081 14.659 15.659C15.081 15.237 15.6533 15 16.25 15C16.8467 15 17.419 15.237 17.841 15.659ZM12 14V22H4C4.00002 19.9216 4.80894 17.9247 6.25547 16.4323C7.702 14.9398 9.67259 14.069 11.75 14.004L12 14ZM12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergen);
export default __webpack_public_path__ + "static/media/allergen.fee3a04b178c5e7c686690d5af7b4e82.svg";
export { ForwardRef as ReactComponent };